class CreditworthinessMoreInfoController {
  constructor() {
    this.moreInfoIsVisible = false;
    this.moreInfoIsDisplayableCtrl = true;
  }

  $onInit() {
    this.moreInfoIsDisplayableCtrl = this.information.hasOwnProperty('information');
  }

  toggleMoreInfo() {
    this.moreInfoIsVisible = !this.moreInfoIsVisible;
  }

  moreInfoIsDisplayable() {
    let isDisplayable = true;
    if(this.information.information === '' || this.moreInfoIsDisplayableCtrl === false){
      isDisplayable = false;
    }
    return isDisplayable;
  }

  getClasses() {
    return {
      'more-info-text-is-show': this.moreInfoIsVisible === true ,
      'more-info-text-is-hide': this.moreInfoIsVisible !== true 
    };
  }
}

export default CreditworthinessMoreInfoController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMoreInfo/creditworthinessMoreInfo.controller.js